import React from 'react';
import { Icon } from 'semantic-ui-react';
import './AddVehicle.scss';

export interface AddVehicleProps {
  onAddVehicle: () => void;
}

const AddVehicle: React.FC<AddVehicleProps> = ({ onAddVehicle }) => (
  <div className="add-vehicle-wrapper" onClick={onAddVehicle}>
    <Icon name="plus circle" className="add-icon" />
    <span>Add new vehicle</span>
  </div>
);

export default AddVehicle;
